/* eslint-disable */
import React, {Component} from 'react';
import {Button, Col, Modal, Row, Table} from "react-bootstrap";
import {Collapse} from 'react-collapse';
import DataTable from "react-data-table-component";
import authService from "../api-authorization/AuthorizeService";
import Form from "react-bootstrap/Form";
import Select, {components, DropdownIndicatorProps} from "react-select";
import add from "../../assets/icons/add.png";
import arrow_up from "../../assets/icons/dark_arrow_up.png";
import arrow_down from "../../assets/icons/dark_arrow_down.png";
import {Typography} from "@material-ui/core";
import del from "../../assets/icons/del.png";
import edit from "../../assets/icons/edit.png";


export class CropsTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            columns: [],
            crops_default: [],
            crops_user: [],
            columns_user: [],
            isModalShow: false,
            isSelectChange: false,
            loading: true,
            isAdd: false,
            error_select: false,
            row_save: {
                id: 0,
                name: '',
                nutrient: {n: 0, p2O5: 0, k2O: 0, s: 0, mg: 0, ca: 0},
                coefSoil: {n: 0, p2O5: 0, k2O: 0, s: 0, mg: 0, ca: 0},
                coefFertilizer: {n: 0, p2O5: 0, k2O: 0, s: 0, mg: 0, ca: 0},
                cropGroupId: 0,
                isBob: false,
                coefBob: 1
            },
            crop_group_list: [],
            rowId: 0,
        }
        this.AddModal = this.AddModal.bind(this)
        this.changeResponse = this.changeResponse.bind(this)
        this.saveResponse = this.saveResponse.bind(this)
    }


    componentDidMount() {
        this.populateCropsData();
    }

    saveResponse = () => {
        if(this.state.isSelectChange){
        fetch('api/crop', {
            method: 'POST',
            headers: !this.props.token ? {} : {
                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.state.row_save)
        }).then((response) => {
            if (response.ok) {
                response.json().then((result) => {
                    this.setState({crops_user: this.state.crops_user.concat(result),
                        isModalShow: false,
                        isSelectChange:false,
                        row_save: {
                            id: 0,
                            name: '',
                            nutrient: {n: 0, p2O5: 0, k2O: 0, s: 0, mg: 0, ca: 0},
                            coefSoil: {n: 0, p2O5: 0, k2O: 0, s: 0, mg: 0, ca: 0},
                            coefFertilizer: {n: 0, p2O5: 0, k2O: 0, s: 0, mg: 0, ca: 0},
                            cropGroupId: 0,
                            isBob: false,
                            coefBob: 1
                        },
                    }, () => {
                        this.forceUpdate()
                    })
                });
            }
        })
        }else{
            this.setState({error_select:true})
        }

    }

    changeResponse = () => {
        fetch('api/crop', {
            method: 'PUT',
            headers: !this.props.token ? {} : {
                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.state.row_save)
        }).then((response) => {
                if (response.ok) {
                    response.json().then((result) => {
                        this.state.crops_user.splice(this.state.crops_user.findIndex((r) => r.id === result.id), 1, result)
                        this.setState({isModalShow: false})
                    })
                }
            }
        )
    }

    handleClickDelete(rowId) {
        fetch('api/crop?id=' + rowId, {
            method: 'DELETE',
            headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`}
        }).then((response) => {
            if (response.ok) {
                this.state.crops_user.splice(this.state.crops_user.findIndex((r) => r.id === rowId), 1)
                this.forceUpdate()
            }
        });
    }


    AddModal(props, isAdd, rowId) {
        const DropdownIndicator = (props: DropdownIndicatorProps<ColourOption, true>) => {
            return (
                <components.DropdownIndicator {...props}>
                    <img src={props.selectProps.menuIsOpen ? arrow_up : arrow_down} alt='arrow-down'
                         className='arrow'></img>
                </components.DropdownIndicator>
            );
        };

        function NoOptionsMessage(props) {
            if (props.options.length) return null;
            return <Typography className='no-options-label' {...props.innerProps}>Нет данных</Typography>;
        }

        let crop = []
        if (!isAdd) {
            crop = this.state.crops_user.find((row) => row.id === rowId)
            this.state.row_save = crop
        }
        return (
            <Modal show={props}
                   backdrop="static"
                   keyboard={false}
                   onHide={() => this.setState({isModalShow: false})}
                   centered
                   size="lg"
                   id="modal-add"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{(isAdd ? "Добавить " : "Редактировать ") + "свою культуру"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <Form onSubmit={this.handleSubmit}>
                            <div className="row">
                                <div className="col">
                                    <Form.Group>
                                        <Form.Label>Наименование культуры</Form.Label>
                                        <Form.Control
                                            placeholder='Наименование'
                                            defaultValue={isAdd ? '' : crop.name}
                                            onChange={(e) => this.state.row_save.name = e.target.value}
                                        />
                                    </Form.Group>
                                </div>
                            </div>
                            <div className="row elements-row">
                                <div className="col">
                                    <Form.Label>Вынос питательных веществ одним центнером основной и соответствующим
                                        количеством побочной
                                        продукции (кг)</Form.Label>
                                    <div className="row">
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>N</i></Form.Label>
                                                <Form.Control type="number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? "" : crop.nutrient.n}
                                                              onChange={(e) => this.state.row_save.nutrient.n = e.target.value}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>P<sub>2</sub>O<sub>5</sub></i></Form.Label>
                                                <Form.Control type="Number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? "" : crop.nutrient.p2O5}
                                                              onChange={(e) => this.state.row_save.nutrient.p2O5 = e.target.value}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>K<sub>2</sub>O</i></Form.Label>
                                                <Form.Control type="Number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? '' : crop.nutrient.k2O}
                                                              onChange={(e) => this.state.row_save.nutrient.k2O = e.target.value}/>
                                            </Form.Group>
                                        </div>
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>S</i></Form.Label>
                                                <Form.Control type="Number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? "" : crop.nutrient.s}
                                                              onChange={(e) => this.state.row_save.nutrient.s = e.target.value}/>
                                            </Form.Group>
                                        </div>
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>CaO</i></Form.Label>
                                                <Form.Control type="Number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? '' : crop.nutrient.caO}
                                                              onChange={(e) => this.state.row_save.nutrient.caO = e.target.value}/>
                                            </Form.Group>
                                        </div>
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>Mg</i></Form.Label>
                                                <Form.Control type="Number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? '' : crop.nutrient.mg}
                                                              onChange={(e) => this.state.row_save.nutrient.mg = e.target.value}/>
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row elements-row">
                                <div className="col">
                                    <Form.Label>Коэффициент использования питательных веществ из запасов почвы
                                        (%)</Form.Label>
                                    <div className="row">
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>N</i></Form.Label>
                                                <Form.Control type="number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? "" : crop.coefSoil.n}
                                                              onChange={(e) => this.state.row_save.coefSoil.n = e.target.value / 100}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>P<sub>2</sub>O<sub>5</sub></i></Form.Label>
                                                <Form.Control type="Number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? "" : crop.coefSoil.p2O5}
                                                              onChange={(e) => this.state.row_save.coefSoil.p2O5 = e.target.value / 100}/>
                                            </Form.Group>
                                        </div>
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>K<sub>2</sub>O</i></Form.Label>
                                                <Form.Control type="Number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? '' : crop.coefSoil.k2O}
                                                              onChange={(e) => this.state.row_save.coefSoil.k2O = e.target.value / 100}/>
                                            </Form.Group>
                                        </div>
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>S</i></Form.Label>
                                                <Form.Control type="Number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? "" : crop.coefSoil.s}
                                                              onChange={(e) => this.state.row_save.coefSoil.s = e.target.value / 100}/>
                                            </Form.Group>
                                        </div>
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>CaO</i></Form.Label>
                                                <Form.Control type="Number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? '' : crop.coefSoil.caO}
                                                              onChange={(e) => this.state.row_save.coefSoil.caO = e.target.value / 100}/>
                                            </Form.Group>
                                        </div>
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>Mg</i></Form.Label>
                                                <Form.Control type="Number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? '' : crop.coefSoil.mg}
                                                              onChange={(e) => this.state.row_save.coefSoil.mg = e.target.value / 100}/>
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row elements-row">
                                <div className="col">
                                    <Form.Label>Коэффициент использования питательных веществ из минеральных удобрений
                                        в 1-й год (%)</Form.Label>
                                    <div className="row">
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>N</i></Form.Label>
                                                <Form.Control type="number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? "" : crop.coefFertilizer.n}
                                                              onChange={(e) => this.state.row_save.coefFertilizer.n = e.target.value / 100}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>P<sub>2</sub>O<sub>5</sub></i></Form.Label>
                                                <Form.Control type="Number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? "" : crop.coefFertilizer.p2O5}
                                                              onChange={(e) => this.state.row_save.coefFertilizer.p2O5 = e.target.value / 100}/>
                                            </Form.Group>
                                        </div>
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>K<sub>2</sub>O</i></Form.Label>
                                                <Form.Control type="Number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? '' : crop.coefSoil.k2O}
                                                              onChange={(e) => this.state.row_save.coefFertilizer.k2O = e.target.value / 100}/>
                                            </Form.Group>
                                        </div>
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>S</i></Form.Label>
                                                <Form.Control type="Number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? "" : crop.coefFertilizer.s}
                                                              onChange={(e) => this.state.row_save.coefFertilizer.s = e.target.value / 100}/>
                                            </Form.Group>
                                        </div>
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>CaO</i></Form.Label>
                                                <Form.Control type="Number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? '' : crop.coefFertilizer.caO}
                                                              onChange={(e) => this.state.row_save.coefFertilizer.caO = e.target.value / 100}/>
                                            </Form.Group>
                                        </div>
                                        <div className="col">
                                            <Form.Group>
                                                <Form.Label><i>Mg</i></Form.Label>
                                                <Form.Control type="Number" min={0}
                                                              placeholder='0'
                                                              defaultValue={isAdd ? '' : crop.coefFertilizer.mg}
                                                              onChange={(e) => this.state.row_save.coefFertilizer.mg = e.target.value / 100}/>
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row bob-row'>
                                <div className="col" style={{maxWidth: '200px'}}>
                                    <label className='checkbox-other'>
                                        <input type="checkbox"
                                               defaultChecked={this.state.row_save.isBob}
                                               onClick={() => {
                                                   this.state.row_save.isBob = !this.state.row_save.isBob
                                                   this.forceUpdate()
                                               }}
                                               key={this.state.row_save.isBob}/>
                                        <span>Бобовая культура</span>
                                    </label>
                                </div>
                                <div className="col">
                                    <Collapse isOpened={this.state.row_save.isBob}>
                                        <Form.Group>
                                            <Row>
                                                <Col className='bob-coef-label'><Form.Label>Коэффициент для бобовых
                                                    культур</Form.Label></Col>
                                                <Col style={{maxWidth: 'fit-content'}}>
                                                    <Form.Control type="Number" min={0}
                                                                  style={{width: '100px', margin: '0 auto'}}
                                                                  defaultValue={isAdd ? "1" : crop.coefBob}
                                                                  onChange={(e) => this.state.row_save.coefBob = e.target.value}
                                                    />
                                                </Col>
                                            </Row>

                                        </Form.Group>
                                    </Collapse>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <Form.Group>
                                        <Form.Label>Пожнивные остатки</Form.Label>
                                        <Select
                                            className={this.state.error_select? 'error-select':''}
                                            maxMenuHeight='244px'
                                            components={{DropdownIndicator, NoOptionsMessage}}
                                            id='crop-group-select'
                                            theme={(theme) => ({
                                                ...theme,
                                                border: '1px solid #ABB3D1',
                                                borderRadius: '10px',
                                                colors: {
                                                    ...theme.colors,
                                                    primary: '#ABB3D1',
                                                },
                                            })}
                                            styles={{
                                                container: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    width: '100%',
                                                    height: '55px',
                                                }),
                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    background: state.isFocused ? '#fff' : '#E9EAEE',
                                                    height: '55px',
                                                    width: '100%',
                                                }),
                                                menu: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    border: ' 1px solid #ABB3D1',
                                                    borderRadius: '10px',
                                                    margin: '0',
                                                    fontSize: '18px !important',
                                                }),
                                                option: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                                    lineHeight: '20px',
                                                    fontSize: '18px !important',
                                                }),
                                                singleValue: (baseSyles) => ({
                                                    ...baseSyles,
                                                    textAlign: 'left',
                                                    fontSize: '18px',
                                                    color: '#201E44',
                                                    margin: '0 !important'
                                                }),
                                            }}
                                            menuPlacement="auto"
                                            menuPosition='absolute'
                                            placeholder='Выберите вашу культуру из группы'
                                            defaultValue={isAdd ? '' : this.state.crop_group_list.find((el) => el.value = crop.cropGroupId)}
                                            options={this.state.crop_group_list}
                                            onChange={(e) => {
                                                this.setState({
                                                    isSelectChange: true,
                                                    error_select:false,
                                                    row_save: {
                                                        id:this.state.row_save.id,
                                                        name:this.state.row_save.name,
                                                        nutrient: this.state.row_save.nutrient,
                                                        coefSoil: this.state.row_save.coefSoil,
                                                        coefFertilizer: this.state.row_save.coefFertilizer,
                                                        cropGroupId: e.value,
                                                        isBob: this.state.row_save.isBob,
                                                        coefBob: this.state.row_save.coefBob
                                                    }
                                                }, ()=>this.forceUpdate())

                                            }}
                                        />
                                    </Form.Group>
                                </div>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className='save-btn' onClick={isAdd ? this.saveResponse : this.changeResponse}>
                        {isAdd ? "Добавить" : "Сохранить"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    static renderTable(columns, crops_default, crops_user, columns_user, add_crop) {
        return (
            <div id='directory-crop-table'>
                <Row className='directory-table-label'>Коэффициенты по культурам</Row>
                <Table className="directory-crop-table-header">
                    <thead className="align-middle">
                    <tr>
                        <th width="14%" rowSpan={2}>Культура</th>
                        <th width="27%" colSpan={6}>Вынос питательных веществ 1 ц основной и соответствующим количеством
                            побочной
                            продукции, кг
                        </th>
                        <th width="27%" colSpan={6}>Коэффициенты использования питательных веществ из запасов почвы, %
                        </th>
                        <th width="27%" colSpan={6}>Коэффициенты использования питательных веществ из минеральных
                            удобрений <br/>в
                            первый год, %
                        </th>
                        <th width="5%" rowSpan={2}>Коэф. для бобовых культур</th>
                    </tr>
                    <tr>
                        <th width="4.5%"><i>N</i></th>
                        <th width="4.5%"><i>P<sub>2</sub>O<sub>5</sub></i></th>
                        <th width="4.5%"><i>K<sub>2</sub>O</i></th>
                        <th width="4.5%"><i>S</i></th>
                        <th width="4.5%"><i>CaO</i></th>
                        <th width="4.5%"><i>Mg</i></th>
                        <th width="4.5%"><i>N</i></th>
                        <th width="4.5%"><i>P<sub>2</sub>O<sub>5</sub></i></th>
                        <th width="4.5%"><i>K<sub>2</sub>O</i></th>
                        <th width="4.5%"><i>S</i></th>
                        <th width="4.5%"><i>CaO</i></th>
                        <th width="4.5%"><i>Mg</i></th>
                        <th width="4.5%"><i>N</i></th>
                        <th width="4.5%"><i>P<sub>2</sub>O<sub>5</sub></i></th>
                        <th width="4.5%"><i>K<sub>2</sub>O</i></th>
                        <th width="4.5%"><i>S</i></th>
                        <th width="4.5%"><i>CaO</i></th>
                        <th width="4.5%"><i>Mg</i></th>
                    </tr>
                    </thead>
                </Table>
                <DataTable
                    data={crops_default}
                    columns={columns}
                    noDataComponent=''
                    noTableHead={true}
                    customStyles={{
                        rows: {
                            style: {
                                fontSize: '16px',
                                fontWeight: '400',
                                lineHeight: '19px',
                                border: '1px solid #ABB3D1 !important',
                                borderTop: '0 !important',
                            }
                        },
                        cells: {
                            style: {
                                borderLeft: "1px solid #ABB3D1",
                                ':first-of-type': {
                                    border: '0 !important',
                                }
                            },
                        },
                    }}
                />
                <DataTable
                    data={crops_user}
                    columns={columns_user}
                    noDataComponent=''
                    noTableHead={true}
                    responsive={false}
                    customStyles={{
                        table: {
                            style: {
                                width: 'calc(100% - 1px)',
                                paddingLeft: '1px'
                            }
                        },
                        rows: {
                            style: {
                                fontSize: '16px',
                                fontWeight: '400',
                                background: ' #F9F9F9',
                                lineHeight: '19px',
                                border: '0',
                                borderBottom: '1px solid #ABB3D1 !important',
                            }
                        },
                        cells: {
                            style: {
                                borderLeft: "1px solid #ABB3D1",
                                ':first-of-type': {
                                    border: '0 !important',
                                }
                            },
                        },
                    }}
                />
                <div className="add-btn-container">
                    <button className="btn add-btn" onClick={add_crop}><img src={add} alt='add'/>
                    </button>
                </div>
            </div>
        );
    }

    render() {
        const add_crop = () => {
            this.setState({isModalShow: true, isAdd: true})
        }
        const crop_table = this.state.loading ?
            <p><em>Загрузка...</em></p> :
            CropsTable.renderTable(
                this.state.columns,
                this.state.crops_default,
                this.state.crops_user,
                this.state.columns_user,
                add_crop)
        return (<>
                <Row className='directory-page-label'>Справочник</Row>
                {crop_table}
                {this.state.isModalShow ? this.AddModal(this.state.isModalShow, this.state.isAdd, this.state.rowId) : <></>}
            </>
        );

    }

    async populateCropsData() {
        const crops_response = await fetch('api/crop', {
            headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`}
        })
        const crops_all = await crops_response.json()
        const crops_default = crops_all.defaultCrop
        const crops_user = crops_all.userCrop
        const crop_group_list = crops_all.groupCrop
        const columns = [{
            selector: row => row.name,
            sortable: true,
            width: "14%",
            wrap: true,
            compact: false
        }, {
            selector: row => (row.nutrient.n).toFixed(2),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => (row.nutrient.p2O5).toFixed(2),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => (row.nutrient.k2O).toFixed(2),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => (row.nutrient.s).toFixed(2),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => (row.nutrient.caO).toFixed(2),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => (row.nutrient.mg).toFixed(2),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefSoil.n * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefSoil.p2O5 * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefSoil.k2O * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefSoil.s * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => (row.coefSoil.caO * 100).toFixed(1),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefSoil.mg * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefFertilizer.n * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefFertilizer.p2O5 * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefFertilizer.k2O * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefFertilizer.s * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefFertilizer.caO * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefFertilizer.mg * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => row.isBob ? row.coefBob : '-',
            width: "5%",
            center: true,
            compact: true
        }]
        const columns_user = [{
            cell: (row) =>
                <button onClick={() => this.setState({isModalShow: true, isAdd: false, rowId: row.id})
                } className="btn edit-row-btn"><img src={edit} alt='edit'/></button>,
            button: true,
            width: "0%"
        }, {
            selector: row => row.name,
            sortable: true,
            width: "14%",
            wrap: true,
            compact: false
        }, {
            selector: row => (row.nutrient.n).toFixed(2),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => (row.nutrient.p2O5).toFixed(2),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => (row.nutrient.k2O).toFixed(2),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => (row.nutrient.s).toFixed(2),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => (row.nutrient.caO).toFixed(2),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => (row.nutrient.mg).toFixed(2),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefSoil.n * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefSoil.p2O5 * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefSoil.k2O * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefSoil.s * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => (row.coefSoil.caO * 100).toFixed(1),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefSoil.mg * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefFertilizer.n * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefFertilizer.p2O5 * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefFertilizer.k2O * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefFertilizer.s * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefFertilizer.caO * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => Math.round(row.coefFertilizer.mg * 100),
            width: "4.5%",
            center: true,
            compact: true
        }, {
            selector: row => row.isBob ? row.coefBob : '-',
            width: "5%",
            center: true,
            compact: true
        }, {
            cell: (row) =>
                <button onClick={() => this.handleClickDelete(row.id)} className="btn delete-row-btn">
                    <img src={del} alt='del'/></button>,
            button: true,
            width: "0px"
        }]

        this.setState({
            columns: columns,
            crops_default: crops_default,
            crops_user: crops_user,
            columns_user: columns_user,
            crop_group_list: crop_group_list,
            loading: false
        });
    }
}
